import { RouteConfig } from 'vue-router';

const errorRoutes: RouteConfig = {
  path: '/error',
  name: 'error',
  component: () => import(/* webpackChunkName: "error" */ '@/pages/error/Index.vue'),
  children: [
    {
      path: '403',
      name: 'error-403',
      component: () => import(/* webpackChunkName: "error" */ '@/pages/error/E403.vue'),
    },
    {
      path: '404',
      name: 'error-404',
      component: () => import(/* webpackChunkName: "error" */ '@/pages/error/E404.vue'),
    },
  ],
};

export default errorRoutes;
